export default {
  faq: {
    error: 'Error al obtener las preguntas frecuentes',
  },
  '403': {
    description:
      'Has completado esta conversación. Para cambios, por favor contacta a la oficina de tu proveedor',
  },
  '404': {
    title: 'Página no encontrada',
    description: 'Lo sentimos, no pudimos encontrar la página que buscas.',
  },
  '500': {
    title: 'Error del servidor',
    description: 'Intenta contactar a nuestro equipo de soporte técnico.',
  },

  waitlist: {
    loading: 'Cargando detalles de la cita...',
    title: 'Un Horario de Cita Está Disponible',
    description:
      '¡Buenas noticias de {{practice}}! Se ha abierto un horario de cita para usted.',
    provider: 'Proveedor',
    date: 'Fecha',
    time: 'Hora',
    accept: 'Aceptar Cita',
    decline: 'Rechazar',
    submitting: 'Enviando...',
    acceptedTitle: 'Cita Confirmada',
    acceptedMessage:
      'Su cita ha sido confirmada. Recibirá una confirmación en breve.',
    declinedTitle: 'Oferta Rechazada',
    declinedMessage:
      'Ha rechazado esta oferta de cita. Permanecerá en la lista de espera para futuras aperturas.',
    expiredTitle: 'Oferta Expirada',
    expiredMessage:
      'Esta oferta de cita ya no está disponible. Se le notificará cuando se abra un nuevo horario.',
    errorTitle: 'Algo Salió Mal',
    errorMessage:
      'No pudimos procesar su solicitud. Por favor intente de nuevo o contacte a su proveedor.',
  },

  settings: {
    fontSize: {
      label: 'Tamaño de letra',
      reset: 'Restablecer',
    },
    resetChat: {
      label: 'Reiniciar chat',
      confirm: {
        title: '¿Estás seguro de que quieres borrar el chat?',
        description: 'Esta acción no se puede deshacer.',
        cancel: 'Cancelar',
        okay: 'Borrar',
      },
    },
    downloadTranscript: {
      label: 'Descargar',
    },
    language: {
      label: 'Idioma',
      'en-US': 'English',
      'es-ES': 'Español',
    },
  },
};
